var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-2 bg-white rounded d-flex justify-space-around align-center"},[_c('h2',{staticClass:"pa-2"},[_vm._v(" You account is blocked, please contact your Administrator ")]),_c('Button',{attrs:{"clickAction":() => _vm.$router.go(-1),"text":"Return"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }